import {
    LinearProgressProps,
    Box,
    LinearProgress,
    Typography,
    useTheme,
} from '@mui/material'
import React from 'react'
import { twMerge } from 'tailwind-merge'

type Props = LinearProgressProps & { value: number, hasPercent?: boolean}
export const SingleProgress = (p: Props) => {
    const { className, sx, hasPercent = false, ...rest } = p
    const muiTheme = useTheme()
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                {hasPercent && <Box
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                        bottom: -15,
                        width: '100%',
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        className={twMerge(
                            'font-bold px-2 rounded-xl opacity-80'
                        )}
                        style={{
                            backgroundColor: muiTheme.palette.background.default,
                        }}
                        variant="body1"
                        color="text.secondary"
                    >
                        {`${Math.round(p.value)}%`}
                    </Typography>
                </Box>}
                <LinearProgress variant="determinate" {...rest} />
            </Box>
        </Box>
    )
}
